import * as React from "react";
import { Button } from "azure-devops-ui/Button";
import { FocusZone, FocusZoneDirection } from "azure-devops-ui/FocusZone";

export default class VerticalExample extends React.Component {
    public render(): JSX.Element {
        return (
            <div style={{ margin: "8px" }}>
                <FocusZone circularNavigation={true} direction={FocusZoneDirection.Vertical}>
                    <div className="flex-column rhythm-vertical-8">
                        <Button text="Button1" />
                        <Button text="Button2" excludeTabStop={true} />
                        <Button text="Button3" excludeTabStop={true} />
                        <Button text="Button4" excludeTabStop={true} />
                    </div>
                </FocusZone>
            </div>
        );
    }
}
